import api from '../Services/AxiosInstance';

export class InfoGenService {
    
    
         getAllInfoByPeriod = async () => {
            try {
              const response = await api.get(`/InfosGen/Cumuls/IPM`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          getPartGen = async (selectedyears) => {
            try {
              const response = await api.get(`/InfosGen/getSoldesParticipant/${selectedyears}`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          getFournGen = async (selectedyears) => {
            try {
              const response = await api.get(`/InfosGen/getSoldesFournisseurs/${selectedyears}`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          getAdhtGen = async (selectedyears) => {
            try {
              const response = await api.get(`/InfosGen/getSoldesAdherents/${selectedyears}`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          
///getSoldesFournisseurs/{exercice}
          getInfosGen = async () => {
            try {
              const response = await api.get(`/InfosGen/IPM`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          
          getLisInfosGen = async () => {
            try {
              const response = await api.get(`/InfosGen/list`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
  
          updateInfosGen = async (payload) => {
            try {
              const response = await api.put(`/InfosGen/update` ,payload,{
                
              });
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
}